export const calendar = {
  title: 'Mi Agenda',
  subtitle: 'Gestione su disponibilidad y sincronice sus calendarios',
  calendar: {
    today: 'Hoy',
    month: 'Mes',
    week: 'Semana',
    day: 'Día',
    selectDates: 'Seleccionar fechas',
    blockDates: 'Bloquear fechas',
    unblockDates: 'Desbloquear estas fechas',
    addNote: 'Añadir nota',
    selectEvent: 'Seleccionar un evento',
    nMonths: 'meses',
    oneMonth: '1 mes',
    months: { january: 'Enero', february: 'Febrero', march: 'Marzo', april: 'Abril', may: 'Mayo', june: 'Junio', july: 'Julio', august: 'Agosto', september: 'Septiembre', october: 'Octubre', november: 'Noviembre', december: 'Diciembre' },
    days: { monday: 'Lun', tuesday: 'Mar', wednesday: 'Mié', thursday: 'Jue', friday: 'Vie', saturday: 'Sáb', sunday: 'Dom' }
  },
  sync: { title: 'Sincronización iCal', description: 'Conecte su calendario de Airbnb o PMS para sincronizar automáticamente su disponibilidad', addConnection: 'Añadir conexión', noConnections: 'Sin conexiones', icalUrl: 'URL iCal', icalUrlPlaceholder: 'https://www.airbnb.com/calendar/ical/...', platform: 'Plataforma', platformPlaceholder: 'Ej: Airbnb, Booking.com, PMS...', syncNow: 'Sincronizar ahora', lastSync: 'Última sincronización', eventsImported: 'eventos importados', status: { synced: 'Sincronizado', pending: 'Pendiente', error: 'Error', syncing: 'Sincronizando...' }, remove: 'Eliminar', edit: 'Editar' },
  exchanges: { title: 'Intercambios próximos', noExchanges: 'Sin intercambios planeados', viewProfile: 'Ver perfil', sendMessage: 'Enviar mensaje', confirm: 'Confirmar', decline: 'Rechazar', cancel: 'Cancelar', guests: 'viajeros', status: { confirmed: 'Confirmado', pending: 'Pendiente', proposal: 'Propuesta', blocked: 'Bloqueado' } },
  legend: { title: 'Leyenda', available: 'Disponible', confirmed: 'Intercambio confirmado', pending: 'Solicitud pendiente', proposal: 'Propuesta', blocked: 'Fechas bloqueadas' },
  blockModal: { title: 'Bloquear fechas', reason: 'Razón (opcional)', reasonPlaceholder: 'Ej: Renovaciones, vacaciones personales...', from: 'Desde', to: 'Hasta', block: 'Bloquear', cancel: 'Cancelar' },
  notifications: { datesBlocked: 'Fechas bloqueadas con éxito', datesUnblocked: 'Fechas desbloqueadas con éxito', syncSuccess: 'Sincronización exitosa', syncError: 'Error de sincronización', connectionAdded: 'Conexión añadida con éxito', connectionRemoved: 'Conexión eliminada', exchangeConfirmed: 'Intercambio confirmado', exchangeDeclined: 'Intercambio rechazado' },
  details: 'Detalles',
  upcomingExchanges: 'Intercambios próximos',
  noExchangesPlanned: 'Sin intercambios planeados',
  daysSelected: 'días seleccionados',
  daySelected: 'día seleccionado',
  from: 'Desde',
  to: 'Hasta',
  reasonOptional: 'Razón (opcional)',
  reasonPlaceholder: 'Ej: Renovaciones, vacaciones personales...',
  block: 'Bloquear',
  cancel: 'Cancelar',
  namePlaceholder: 'Nombre (ej: Airbnb)',
  filters: 'Filtros',
  actions: 'Acciones',
  connections: 'Conexiones'
};

export default calendar;
